export enum BatchStatusEnum{

    Draft = 1,
    Approval = 2,
    Suspended = 10,
    Cancelled = 15,
    CancelledBySystem = 16,
    Active = 20,
    Closed = 50
}
